import EventEmitter from 'node:events';
import type { LooseAppManifest } from '@wix/cli-app-manifest';

interface ManifestUpdatedPayload {
  armTag: string;
  updatedComponents: LooseAppManifest['components'];
}

interface DevCenterWatcherEvents {
  manifestUpdated: [payload: ManifestUpdatedPayload];
}

export class DevCenterWatcher extends EventEmitter<DevCenterWatcherEvents> {
  onManifestUpdated(listener: (payload: ManifestUpdatedPayload) => void) {
    this.on('manifestUpdated', listener);
    return () => this.off('manifestUpdated', listener);
  }
}
